import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
export function useVideoStructuredData(data) {
  // 	M57 Video Detail Header +
  // PersonalizablePrimaryHeader +
  // HeaderMedia +
  // HeaderMedia360
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSingleComponent = _useState2[0],
    setIsSingleComponent = _useState2[1];
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var inlineScript = document.createElement('script');
      inlineScript.setAttribute('id', 'structured-video-object');
      inlineScript.setAttribute('type', 'application/ld+json');
      if (Object.keys(data).length) {
        inlineScript.innerHTML = "".concat(data);
      }
      var videoScripts = Array.from(document.querySelectorAll('#structured-video-object'));
      if (videoScripts.length === 0) {
        document.body.append(inlineScript);
        setIsSingleComponent(true);
      } else {
        setIsSingleComponent(false);
      }
      return function () {
        inlineScript.remove();
      };
    }
  }, [isSingleComponent]);
}